/* eslint-disable react-hooks/exhaustive-deps */
// Too hard to untangle all the effects on this page and make them conform to this rule

import { bedbankOfferProductDetailView } from 'actions/AnalyticsActions'
import { fetchBedbankOfferById, fetchCalendarForBedbankOffer, fetchRatesForBedbankOffer } from 'actions/BedbankOfferActions'
import { fetchFlightCalendar } from 'actions/FlightActions'
import { fetchRelatedTravelItems, fetchTraderInformation, offerViewed } from 'actions/OfferActions'
import ErrorBoundary from 'components/Common/ErrorBoundary'
import HeadData from 'components/Common/HeadData'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import OfferRecommendations from 'components/Common/OfferRecommendations'
import Pane from 'components/Common/Pane'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import BedbankOfferContent from 'components/OfferPage/Bedbank/BedbankOfferContent'
import BedbankNavigableOfferContent from 'components/OfferPage/NavigableOfferContent/BedbankNavigableOfferContent'
import { BottomMobileRelatedTravelItems } from 'components/OfferPage/RelatedTravelItems'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import Error500Page from 'components/Pages/Error500Page'
import { replace, RouterLocation } from 'connected-react-router'
import config from 'constants/config'
import { urlHashDatePicker } from 'constants/url'
import OfferPageStateProvider from 'contexts/OfferPage/offerPageStateProvider'
import { OfferPageActions, OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { useAppDispatch } from 'hooks/reduxHooks'
import { getPromotionDefaultPeriod } from 'lib/hotels/bedbankUtils'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { ENABLED_OFFER_TYPES_RECENTLY_VIEWED } from 'lib/offer/highIntentOffers'
import { generateRoomOccupants, sumUpOccupancies } from 'lib/offer/occupancyUtils'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { getPromotionMinLos } from 'selectors/offerPage/bedbankOfferPageSelectors'
import { getDefaultAirport, selectIsBedbankFlightBookingEnabled } from 'selectors/flightsSelectors'
import { getInitialBedbankOfferPageState } from 'selectors/offerPage/initialOfferPageStateSelectors'
import styled from 'styled-components'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton/BookmarkButton'
import ImmersiveSaveButtonPortal from 'tripPlanner/components/ImmersiveHeader/ImmersiveSaveButtonPortal'
import HotelStructuredData from './HotelStructuredData'
import * as Analytics from 'analytics/analytics'
import { accommodationOfferClicked } from 'analytics/eventDefinitions'
import { offerPageDurationChangeEvent, offerPageGuestSelectionEvent, offerPageHotLeadEvent } from 'analytics/snowplow/events'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import useOfferPageReducer from 'hooks/OfferPage/useOfferPageReducer'
import { useSaveHotLead } from 'hooks/Recommendation/useSaveHotLead'
import BusinessTravellerStickyBudgetBar from 'businessTraveller/components/budget-bar/accommodation/BusinessTravellerStickyBudgetBar'
import zIndex from 'styles/tools/z-index'
import HttpStatus from 'components/Common/HttpStatus'
import { RecommendationsFilters } from 'components/OfferList/OfferListTiles/YouMayAlsoLikeTile/Common/types'
import OfferYmalStickyFooter from 'components/Recommendations/YouMayAlsoLike/Offer/OfferYmalStickyFooter'
import offerPageURL from 'lib/offer/offerPageURL'
import { usePageActivityTracking } from 'analytics/snowplow/helpers/useActivityTracking'
import { rem } from 'polished'
import SavePromptHotel from 'tripPlanner/components/Bookmark/SavePrompt/SavePromptHotel'
import { encodeSearchParams } from 'lib/search/searchUtils'
import moment from 'moment'
import OfferPageSignUpWall from 'components/Common/OfferPageSignUpWall'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import useMountedEffect from 'hooks/useMountedEffect'
import { LuxPlusLabelProvider } from 'contexts/LuxPlusLabelContext'
import { ReducerMiddleware } from 'lib/redux/reducerUtils'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import bedbankMobileFilterMiddleware from 'components/OfferPage/Bedbank/MobileBookingFlow/BedbankMobileFilterMiddleware'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import useEuropeOfferPageWalledGarden from 'hooks/OfferPage/useEuropeOfferPagWalledGarden'
import useMetasearchSourceTransition from 'hooks/OfferPage/useMetasearchSourceTransition'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import Group from 'components/utils/Group'

const StyledBusinessTravellerStickyBudgetBar = styled(BusinessTravellerStickyBudgetBar)`
  z-index: ${zIndex.floatingPanel};
`

const MainContent = styled(Group)`
  flex-grow: 1;
`

const NavigableContentPane = styled(Pane)`
  padding-bottom: ${rem(24)};
`
const OfferPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ObservableWrapper = styled.div`
  padding-top: 1px;
`

export const initialRooms = [generateRoomOccupants()]
const mobileVariantMiddlewares:Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = [bedbankMobileFilterMiddleware]
interface Props extends RouteComponentProps<{ offerSlug: string, offerId: string }> {
  fetching: boolean;
  offer?: App.BedbankOffer;
  offerError?: any;
  regionCode: string;
  currency: string;
  promotionMinLos: number;
  defaults: Partial<OfferPageState>;
  headlessMode: boolean;
  traderInformation?: App.TraderInformation;
  defaultAirport?: App.Airport;
  isBedbankFlightBookingEnabled: boolean;
  relatedTravelItems: App.OfferState['relatedTravelItems'];
  lereLoadingError?: any;
  propertyPageOfferId?: string;
  isSpoofed: boolean,
  routerLocation: RouterLocation<unknown>,
}

function BedbankOfferPage(props: Props) {
  const {
    fetching,
    match,
    offer,
    offerError,
    regionCode,
    currency,
    defaults,
    location,
    headlessMode,
    defaultAirport,
    isBedbankFlightBookingEnabled,
    relatedTravelItems,
    traderInformation,
    propertyPageOfferId,
    promotionMinLos,
    isSpoofed,
    routerLocation,
  } = props

  const dispatch = useAppDispatch()
  const [showNavOfferContent, setShowNavOfferContent] = useState(false)
  const [middlewares, setMiddlewares] = useState<Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> | undefined>(undefined)

  const offerId = propertyPageOfferId || match.params.offerId
  const dataLoaded = useRef(false)

  const isMobileScreen = useScreenSizeOnly('mobile')
  const isNewMobileBookingFlowEnabled = useOptimizelyExperiment(OptimizelyExperiments.croLPPNewMobileBooking, isMobileScreen)
  const useNewMobileBookingFlow = isMobileScreen && isNewMobileBookingFlowEnabled

  const [state, stateDispatch] = useOfferPageReducer({
    ...defaults,
    airport: defaultAirport,
    bedbankOffer: offer,
  }, middlewares)

  const hasTransitionedFromMetasearch = useMetasearchSourceTransition()
  /**
   * 1. go to a YMAL recommendation
   * 2. Refresh page (clears redux)
   * 3. Go back
   * 4. FETCH_BEDBANK_OFFER action fires, but reducer already computed its initialState where bedbankoffer was initially undefined
   * 5. Fetch done -> loading indicator disappears, component crashes
   *
   * This useEffect is a workaround that.
   */
  useEffect(() => {
    if (offer) {
      stateDispatch({ type: OfferPageActions.setBedBankOffer, bedbankOffer: offer })
      if (defaults.duration) {
        stateDispatch({ type: OfferPageActions.setDuration, duration: defaults.duration })
      }
    }
  }, [offer])

  useEffect(() => {
    if (useNewMobileBookingFlow) {
      setMiddlewares(mobileVariantMiddlewares)
    } else {
      setMiddlewares(undefined)
    }
  }, [useNewMobileBookingFlow])

  const {
    activeFilter,
    checkInDate,
    checkOutDate,
    rooms,
    airport,
    duration,
    selectedBedbankRoomId,
  } = state

  const isWalledGardenEuropeOffersEnabled = useEuropeOfferPageWalledGarden()

  useEffect(() => {
    if (offer) {
      // we use dataLoaded ref to prevent multiple analytics pushes
      fireEcommerceGTMEvent(accommodationOfferClicked(offer, currency))
      dataLoaded.current = true
    }
  }, [offer, currency])

  usePageActivityTracking()

  useEffect(() => {
    if (!showNavOfferContent && location.hash && location.hash !== urlHashDatePicker) {
      setShowNavOfferContent(true)
    }
  }, [location.hash])

  useEffect(() => {
    if (showNavOfferContent) {
      window.location.href = location.hash
    }
  }, [showNavOfferContent])

  useEffect(() => {
    if (!activeFilter && location.hash === urlHashDatePicker) {
      dispatch(replace({ ...location, hash: undefined }))
    }
  }, [activeFilter])

  useEffect(() => {
    if (location.hash === urlHashDatePicker) {
      stateDispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    }
  }, [location.hash])

  useEffect(() => {
    if (offer && ENABLED_OFFER_TYPES_RECENTLY_VIEWED.has(offer.type)) {
      dispatch(offerViewed(offer.id, offer.type, !offer.sell?.price))
    }
  }, [offer, dispatch])

  const occupancyNumber = useMemo(() => sumUpOccupancies(rooms), [rooms])
  const flightsEnabled = !!offer?.flights?.flightsEnabled && isBedbankFlightBookingEnabled && occupancyNumber < 10

  const queryString = useMemo(() =>
    encodeSearchParams({
      urlSearch: routerLocation.search,
      dates: {
        checkIn: checkInDate,
        checkOut: checkOutDate,
      },
      rooms,
    }).toString(), [checkInDate, checkOutDate, rooms, routerLocation.search])

  useEffect(() => {
    if (offer) {
      dispatch(fetchRelatedTravelItems(offer, checkInDate, checkOutDate, rooms))
    }
  }, [offer, checkInDate, checkOutDate, rooms])

  // This one is used to load the section before the user gets to it
  const [navigableRef, navigableInView] = useInView({
    triggerOnce: true,
    rootMargin: '500px',
  })

  useEffect(() => {
    dispatch(fetchBedbankOfferById(offerId, { regionCode, flightOrigin: airport?.code }))
  }, [offerId])

  useEffect(() => {
    if (isEnabledForFeature(config.TRADER_INFORMATION_REGIONS!, regionCode)) {
      dispatch(fetchTraderInformation(offerId, regionCode))
    }
  }, [offerId])

  useEffect(() => {
    if (!activeFilter || hasTransitionedFromMetasearch) {
      if (offer && checkInDate && checkOutDate && rooms?.length) {
        dispatch(fetchRatesForBedbankOffer(offer, rooms, checkInDate, checkOutDate, hasTransitionedFromMetasearch))
      }
    }
  }, [offerId, checkInDate, checkOutDate, rooms, offer?.id, activeFilter, hasTransitionedFromMetasearch])

  const checkInMoment = useMemo(() => checkInDate ? moment(checkInDate) : undefined, [checkInDate])
  const checkOutMoment = useMemo(() => checkOutDate ? moment(checkOutDate) : undefined, [checkOutDate])
  const selectedDuration = useMemo(() => checkOutMoment?.diff(checkInMoment, 'days'), [checkInMoment, checkOutMoment])
  const hotLead = useSaveHotLead({
    offerId,
    offerType: 'bedbank_hotel',
    checkInDate,
    checkOutDate,
    duration: selectedDuration,
    occupancy: rooms,
  })

  useEffect(() => {
    if (offer && hotLead?.checkIn && hotLead.checkOut) {
      Analytics.trackEvent(offerPageHotLeadEvent(offer, state))
    }
  }, [hotLead])

  useMountedEffect(() => {
    if (state.rooms && offer) {
      Analytics.trackEvent(offerPageGuestSelectionEvent(offer, state))
    }
  }, [state.rooms])

  useMountedEffect(() => {
    if (selectedDuration && offer) {
      Analytics.trackEvent(offerPageDurationChangeEvent(offer, state))
    }
  }, [selectedDuration])

  useEffect(() => {
    if (offerId && config.BEDBANK_NEW_CALENDAR && duration && promotionMinLos <= duration) {
      dispatch(fetchCalendarForBedbankOffer(offerId, duration, selectedBedbankRoomId))
    }
  }, [offerId, rooms, duration, promotionMinLos, selectedBedbankRoomId])

  const hasPromotions = (offer?.promotions ?? []).length > 0

  useEffect(() => {
    if (offer?.flights.airportCode && flightsEnabled && airport && duration && promotionMinLos <= duration && config.BEDBANK_NEW_CALENDAR) {
      dispatch(fetchFlightCalendar({
        ...getPromotionDefaultPeriod(),
        origin: airport.code,
        destination: offer.flights.airportCode,
        nights: duration,
      }))
    }
  }, [offer, airport, flightsEnabled, promotionMinLos, duration])

  useEffect(() => {
    if (offer) {
      dispatch(bedbankOfferProductDetailView(offer))
      window.dataLayer?.push({ offerType: offer.type })
    }
  }, [offerId])

  useEffect(() => {
    dispatch(replace({ ...routerLocation, search: queryString }))
  }, [queryString])

  const isBusinessUser = config.businessTraveller.currentAccountMode === 'business'

  // ------------- LERE sticky footer -------------------
  const ymalStickyFooterHideTrigger = useInView({ triggerOnce: false })
  const ymalStickyFooterShowTrigger = useInView({ triggerOnce: true })

  const canShowYmalFooter = ymalStickyFooterShowTrigger.inView && !ymalStickyFooterHideTrigger.inView && !useNewMobileBookingFlow
  const showRecommendations = !hasPromotions && !!offer && !isBusinessUser && !isSpoofed && !useNewMobileBookingFlow

  const recommendationFilters = useMemo<RecommendationsFilters>(() => ({
    propertyId: `bedbank:${offerId}`,
    searchNearby: true,
    checkIn: checkInDate,
    checkOut: checkOutDate,
    rooms,
  }), [offer, offerId, activeFilter, checkInDate, checkOutDate, rooms])
  // ------------- END of LERE sticky footer -------------------

  if (offerError) {
    if (offerError?.status == 404) {
      return <HttpStatus code={404}>
        <Error404PageWithOffers />
      </HttpStatus>
    } else {
      <HttpStatus code={500}>
        return <Error500Page error={offerError} />
      </HttpStatus>
    }
  }

  if (fetching || !offer || !state.bedbankOffer) {
    return <LoadingIndicator data-testid="bedbank-offer-loading-indicator" />
  }

  if (match.params.offerSlug && (offer.slug !== match.params.offerSlug)) {
    return <RedirectWithStatus code={301} to={`/${regionCode.toLowerCase()}${offerPageURL(offer)}`} />
  }

  const metaDescription = `Book the best deal for ${offer.name}, ${offer.property.address.city} with Luxury Escapes today. The world's best escapes, handpicked by experts!`
  const breadCrumbItems = relatedTravelItems[offer?.id] || []

  return <AnalyticsPageContext.Provider value={AnalyticsPage.offerPage} >
    <OfferPageStateProvider state={state} dispatch={stateDispatch}>
      <MainContent direction="vertical" verticalAlign="space-between">
        <div>
          <ImmersiveSaveButtonPortal>
            <BookmarkButton offer={offer} />
          </ImmersiveSaveButtonPortal>
          <TripGuard>
            <SavePromptHotel offer={offer} />
          </TripGuard>
          <HeadData
            title={`${offer.name}, ${offer.property.address.city} - ${config.title} ${regionCode}`}
            description={metaDescription}
            imageId={offer.images[0]?.id || undefined}
          />
          <HotelStructuredData offer={offer} />
          <StyledBusinessTravellerStickyBudgetBar
            checkInDate={checkInDate}
            checkOutDate={checkOutDate}
            offer={offer}
            roomCount={rooms?.length}
          />
          <OfferPageWrapper className="OfferPage">
            <LuxPlusLabelProvider page="offer-page">
              <BedbankOfferContent
                flightsEnabled={flightsEnabled}
                ymalStickyFooterHideTriggerRef={ymalStickyFooterHideTrigger.ref}
                ymalStickyFooterShowTriggerRef={ymalStickyFooterShowTrigger.ref}
                canShowYmalFooter={canShowYmalFooter}
              />
            </LuxPlusLabelProvider>
          </OfferPageWrapper>
        </div>
        <SoftOfferPageWalledGarden bypassWall={isWalledGardenEuropeOffersEnabled} wall={<OfferPageSignUpWall offerType="hotel" />}>
          <ObservableWrapper ref={navigableRef}>
            <NavigableContentPane>
              {(navigableInView || showNavOfferContent) && (
                <BedbankNavigableOfferContent
                  offer={offer}
                  traderInformation={traderInformation}
                  hash={location.hash}
                />
              )}
            </NavigableContentPane>
          </ObservableWrapper>
          <ErrorBoundary fallback={null}>
            {!isBusinessUser && <OfferRecommendations
              filters={recommendationFilters}
              offerId={offer.id}
              trackingDescription="Bedbank"
              enableDateCheckingForPriceDisplay
            />}
          </ErrorBoundary>
          <ObservableWrapper>
            {!headlessMode &&
              <BottomMobileRelatedTravelItems offer={offer} items={breadCrumbItems} title="Travel Destinations" />
      }
          </ObservableWrapper>
          {showRecommendations && (
            <ErrorBoundary fallback={null}>
              <OfferYmalStickyFooter
                seedOffer={offer}
                filters={recommendationFilters}
                show={canShowYmalFooter}
                initialShowDelayMs={2000}
                hideImmediately={!!activeFilter}
                pageSource="Bedbank"
              />
            </ErrorBoundary>
          )}
        </SoftOfferPageWalledGarden>
      </MainContent>
    </OfferPageStateProvider>
  </AnalyticsPageContext.Provider>
}

const mapStateToProps = (state: App.State, ownProps: Partial<Props>) => {
  const offerId = ownProps.propertyPageOfferId || ownProps.match?.params?.offerId || ''
  const offer: App.BedbankOffer | undefined = state.offer.bedbankOffers[offerId]

  return {
    regionCode: state.geo.currentRegionCode,
    currency: state.geo.currentCurrency,
    fetching: !!state.offer.offersLoading[offerId] && !offer,
    offer,
    traderInformation: state.offer.traderInformation[offerId]?.data,
    offerError: state.offer.offerErrors[offerId],
    defaults: getInitialBedbankOfferPageState(state, offer),
    promotionMinLos: getPromotionMinLos(offer),
    headlessMode: state.system.headlessMode,
    defaultAirport: getDefaultAirport(state),
    isBedbankFlightBookingEnabled: selectIsBedbankFlightBookingEnabled(state),
    relatedTravelItems: state.offer.relatedTravelItems,
    isSpoofed: state.auth.account.isSpoofed,
    routerLocation: state.router.location,
  }
}

export default withRouter(connect(mapStateToProps)(BedbankOfferPage))
